export default [
  'ResourceService',
  class OffersService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/offers';
    }

    subscribe(email, _email) {
      if (!email || typeof _email === 'undefined') {
        return this._resourceService.errorPromise('offers:subscribe: missing parameters');
      }
      return this._resourceService.post(`${this._API_BASE}/subscribe`, {
        'email': email,
        '_email': _email
      });
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/api-services/offers-service.js